import { Config } from '@adornis/config/config.js';

export const config = new Config('gradias', {
  OPENROUTER_API_KEY: {
    client: false,
    required: true,
    env: true,
    name: 'OPENROUTER_API_KEY',
  },
  ADMIN_USER_IDS: {
    client: false,
    required: false,
    env: true,
    name: 'ADMIN_USER_IDS',
    defaultVal: '',
  },
  // Job-system tuning. Empty = use the code's default; every knob and its reasoning is in
  // db/api/jobs/limits.ts.
  /**
   * How many jobs this process runs at once. Default 25.
   *
   * The only concurrency knob there is. It replaced a heap-reservation system whose per-job budgets throttled the
   * process to about four jobs while declaring memory nobody used — see the header of db/api/jobs/load.ts. What
   * bounds memory now are limiters at the two fan-outs that could exhaust it (PDF page rasterisation, per-region
   * OCR) plus accepting that the process can be killed and making that cheap.
   */
  JOB_CONCURRENCY: {
    client: false,
    required: false,
    env: true,
    name: 'JOB_CONCURRENCY',
    defaultVal: '',
  },
  /**
   * Model calls allowed in flight at once across the whole FLEET. Default 40. Divided by
   * `LLM_EXPECTED_REPLICAS` to get this process's share (see llm/llm-gate.ts).
   */
  LLM_MAX_CONCURRENT_CALLS: {
    client: false,
    required: false,
    env: true,
    name: 'LLM_MAX_CONCURRENT_CALLS',
    defaultVal: '',
  },
  /**
   * How many instances of this process run against the same provider account. The gate counts promises in one
   * Node heap and so can only ever be per-process; this is what keeps the fleet total at the intended number
   * when replicas are scaled up. Default 1.
   */
  LLM_EXPECTED_REPLICAS: {
    client: false,
    required: false,
    env: true,
    name: 'LLM_EXPECTED_REPLICAS',
    defaultVal: '',
  },
  /**
   * The longest a job may hold its claim, in minutes. Nothing can extend it, so this doubles as the maximum job
   * runtime and as how long a hard crash goes unnoticed. Default 30.
   */
  JOB_MAX_RUNTIME_MIN: {
    client: false,
    required: false,
    env: true,
    name: 'JOB_MAX_RUNTIME_MIN',
    defaultVal: '',
  },
  /**
   * Seconds a claimed job gets to finish on its own during shutdown before it is handed back to the queue.
   * Default 15. Set it to 1 or 2 in development, where waiting out a handler that ignores its abort signal is
   * only friction — the hard-exit deadline is derived from this, so lowering it makes the whole stop faster.
   *
   * RAISING it has a ceiling this process cannot check: hard exit is this + 10s and must stay under the container's
   * `stop_grace_period` (40s in deploy/*-compose.yml, so at most 29 here). The resolved pair is printed at boot as
   * `jobDrainMs` / `requiresComposeGraceAbove`; raise the compose value first if you need more.
   */
  JOB_DRAIN_SEC: {
    client: false,
    required: false,
    env: true,
    name: 'JOB_DRAIN_SEC',
    defaultVal: '',
  },
});
